import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';

import { PrivacyPolicy } from '@modules/privacyPolicy/PrivacyPolicy';

const TITLE = 'Qeeper - Privacy Policy';
const DESC = 'Qeeper privacy policy.';
const URL = 'https://www.qeeper.co.uk/privacy-policy';

const SEO_KEYWORDS = 'Qeeper privacy policy';

const TermsAndConditionsPage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <PrivacyPolicy />
    </>
  );
};

export default TermsAndConditionsPage;
